"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceWordWithStatusSchema = exports.SentenceWordWithSpecialWordDataSchema = exports.isSentenceWord = exports.SentenceWordSchema = exports.TagSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const image_association_types_1 = require("../image_association_types");
exports.TagSchema = zod_1.z.object({
    id: zod_1.z.string(),
    images: image_association_types_1.ImageSchema.array().optional(),
    text: zod_1.z.string(),
});
exports.SentenceWordSchema = zod_1.z.object({
    abstract: zod_1.z.boolean(),
    child_index: zod_1.z.number().optional(),
    id: zod_1.z.string(),
    known_txt: zod_1.z.string(),
    known_word_id: zod_1.z.string(),
    learn_txt: zod_1.z.string(),
    learn_word_id: zod_1.z.string(),
    post_learn_txt: zod_1.z.string(),
    pre_learn_txt: zod_1.z.string(),
    reading: zod_1.z.string().optional(),
    root_txt: zod_1.z.string(),
    root_word_id: zod_1.z.string(),
    sentence_id: zod_1.z.string().optional(),
    sentence_order: zod_1.z.number(),
    tags: exports.TagSchema.array().optional(),
    vulgar: zod_1.z.boolean(),
});
exports.isSentenceWord = type_validation_helpers_1.getTypeValidationFunction(exports.SentenceWordSchema);
exports.SentenceWordWithSpecialWordDataSchema = exports.SentenceWordSchema.extend({
    is_625_word: zod_1.z.boolean().optional(),
});
exports.SentenceWordWithStatusSchema = exports.SentenceWordSchema.extend({
    marked_known: zod_1.z.boolean(),
    marked_skipped: zod_1.z.boolean(),
    root_word_card_exists: zod_1.z.boolean(),
    sentence_word_card_exists: zod_1.z.boolean(),
});
//# sourceMappingURL=sentence_word_types.js.map